;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "PQgI46RFfV"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {

  let left = $(this).find('.lh-left .lh-item');
  let right = $(this).find('.lh-right .lh-item');

  let removeAllActive = function(items, contents ) {
    items.each( function(i) {
      let hasClass = this.classList.contains('active');
      if(hasClass) {
        this.classList.remove('active')
        contents[i].style.maxHeight = `0`
      }
    });
  }

  let eventAc = function(dom) {
    let heads = dom.find('.lh-head');
    let contents = dom.find('.lh-content');

    heads.each( function(i) {
      this.addEventListener('click', () => {
        let wrap = this.parentNode;
        let currentHasAc = wrap.classList.contains('active');
        if(!currentHasAc) {
          removeAllActive(dom, contents);
          wrap.classList.add('active');
          contents[i].style.maxHeight = `${contents[i].scrollHeight}px`
        } else {
          removeAllActive(dom, contents);
        }
      })
    })
  }
  eventAc(left);
  eventAc(right);

 };						cb.bind($('section[data-section-id="PQgI46RFfV"] include[data-name="style_2"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="PQgI46RFfV"]').get(0))({						url: "https://library.layouthub.com/HUB/files/U2VwLS0yMDIw/NTk5NDQ1MzA1/shopify-third-release/pages/zQBV8XqNDpendIr0/faq/",						settings: {}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "oviazunpc4"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {

  let left = $(this).find('.lh-left .lh-item');
  let right = $(this).find('.lh-right .lh-item');

  let removeAllActive = function(items, contents ) {
    items.each( function(i) {
      let hasClass = this.classList.contains('active');
      if(hasClass) {
        this.classList.remove('active')
        contents[i].style.maxHeight = `0`
      }
    });
  }

  let eventAc = function(dom) {
    let heads = dom.find('.lh-head');
    let contents = dom.find('.lh-content');

    heads.each( function(i) {
      this.addEventListener('click', () => {
        let wrap = this.parentNode;
        let currentHasAc = wrap.classList.contains('active');
        if(!currentHasAc) {
          removeAllActive(dom, contents);
          wrap.classList.add('active');
          contents[i].style.maxHeight = `${contents[i].scrollHeight}px`
        } else {
          removeAllActive(dom, contents);
        }
      })
    })
  }
  eventAc(left);
  eventAc(right);

 };						cb.bind($('section[data-section-id="oviazunpc4"] include[data-name="style_2"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="oviazunpc4"]').get(0))({						url: "https://library.layouthub.com/HUB/files/U2VwLS0yMDIw/NTk5NDQ1MzA1/shopify-third-release/pages/zQBV8XqNDpendIr0/faq/",						settings: {}					}, jQuery);})(jQuery);;console.log('This page layout has been built by https://www.layouthub.com');window.addEventListener("load",()=>{let a=document.querySelector("body"),b=document.createElement(Math.random().toString(36).replace(/\d*/g,"").substr(2,4));b.setAttribute("style",["position:relative","top: 0px","left: 0px","display: inline-block","height: 30px","line-height: 30px","font-size: 15px","width: 100%","text-align: center","opacity: 1","z-index: 10000000000000000","text-indent: 0","color: #333","background: #fff",""].join(" !important;")),b.innerHTML="Page layout provided by &hearts; <a href=\"https://www.layouthub.com/?utm_source=client-site&utm_medium=footer&utm_campaign=freemium&utm_term=links&utm_content="+window.location.origin+"\">Layouthub.com</a>",a.appendChild(b)});